import React from "react";
import { Bar, BarChart, Brush, Label, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import "./Login.scss";

const LoginGrafica = (props) => {
    const {datosGrafica} = props;
    var tooltip = "";

    const CustomTooltip = ({active, payload, label}) => {
        if (active && payload && payload.length) {
            for(const bar of payload) {
                if(bar.dataKey === tooltip) {
                    if(tooltip === "porcentajeOtros") {
                        return (
                            <div className="tooltipGrafica">
                                <b>&nbsp;Cancelada: </b>{bar.payload.canceladas}&nbsp;<br />
                                <b>&nbsp;Declinada: </b>{bar.payload.declinadas}&nbsp;<br />
                                <b>&nbsp;Denegada: </b>{bar.payload.denegadas}&nbsp;<br />
                                <b>&nbsp;No completó los requisitos: </b>{bar.payload.noComp}&nbsp;<br />
                                <b>&nbsp;Registrado en otro sistema: </b>{bar.payload.roSist}&nbsp;
                            </div>
                        );
                    } else {
                        return (
                            <div className="tooltipGrafica">
                                <b>&nbsp;{TooltipTitulo(tooltip)}&nbsp;</b><br/>&nbsp;{TooltipCount(tooltip, bar.payload)}
                            </div>
                        );
                    }
                }
            }
        }
        return null;
    };

    const TooltipTitulo = (tooltip) => {
        if(tooltip === "porcentajeRec") {
            return "Solicitudes recibidas";
        }
        if(tooltip === "porcentajeVal") {
            return "Solicitudes validadas";
        }
        if(tooltip === "porcentajeCap") {
            return "Solicitudes capacitadas";
        }
        if(tooltip === "porcentajeAcre") {
            return "Solicitudes acreditadas";
        }
        return "";
    }

    const TooltipCount = (tooltip, info) => {
        if(tooltip === "porcentajeRec") {
            return info.recibidas;
        }
        if(tooltip === "porcentajeVal") {
            return info.validadas;
        }
        if(tooltip === "porcentajeCap") {
            return info.capacitadas;
        }
        if(tooltip === "porcentajeAcre") {
            return info.acreditadas;
        }
        return 0;
    }

    const formato = () => {
        return;
    }
        
    if(datosGrafica.length > 0) {
        return (
            <div style={{textAlign:'left', maxHeight:"335px"}}>
                <ResponsiveContainer width="100%" minHeight={300} maxHeight={1040}>
                    <BarChart width={730} minHeight={300} maxHeight={1040} data={datosGrafica} layout="vertical">
                        <XAxis type="number">
                            <Label value="% de avance" position="insideBottomRight" offset={0}/>
                        </XAxis>
                        <YAxis type="category" dataKey="nombreEstado" width={100}/>
                        <Tooltip content={<CustomTooltip />} />
                        <Legend verticalAlign="top" align="right" iconType="circle" 
                            wrapperStyle={{fontSize: "12px", paddingRight: "50px"}} />
                        <Brush dataKey={"nombreEstado"} startIndex={0} endIndex={1} height={20} fill="#F2F2F2"
                            tickFormatter={() => formato()} y={280} />
                        <Bar dataKey="porcentajeRec" fill="#FF8C8C"  name="Recibidas" 
                            onMouseOver={() => tooltip="porcentajeRec"} onMouseOut={() => tooltip=""}/>
                        <Bar dataKey="porcentajeVal" fill="#2CC9D6" name="Validadas" 
                            onMouseOver={() => tooltip="porcentajeVal"} onMouseOut={() => tooltip=""}/>
                        <Bar dataKey="porcentajeCap" fill="#A867EE" name="Capacitadas" 
                            onMouseOver={() => tooltip="porcentajeCap"} onMouseOut={() => tooltip=""}/>
                        <Bar dataKey="porcentajeAcre" fill="#DB2491" name="Acreditadas" 
                            onMouseOver={() => tooltip="porcentajeAcre"} onMouseOut={() => tooltip=""}/>
                        <Bar dataKey="porcentajeOtros" fill="#9D9D9D" name="Otros estatus" 
                            onMouseOver={() => tooltip="porcentajeOtros"} onMouseOut={() => tooltip=""}/>
                    </BarChart>
                </ResponsiveContainer>
            </div>
        );
    } else {
        return <div>Cargando...</div>
    }
};

export default LoginGrafica;